<template>
	<div class="df1" v-loading.fullscreen.lock="loading">
		<el-form ref="form" :model="form" :rules="rules"  
		              label-position="top">
					 
			<el-form-item label="名字" prop="name" > 
				<el-input v-model="form.name" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="邮箱" prop="eMail">
				<el-input v-model="form.eMail" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="签约主体所在地" prop="country">
				 <el-input v-model="form.country" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="公司类型" prop="companyType">
				<el-select v-model="form.companyType" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in companyTypeOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<el-form-item label="现在合作的发行商" prop="current">
				 <el-input v-model="form.current" placeholder="" ></el-input>
			</el-form-item> 		
			
			<el-form-item label="停止合作的原因" prop="arrangement">
				 <el-input v-model="form.arrangement" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="过往发行的歌曲目录清单（需包含专辑名、歌曲名、演唱者、ISRC编码等必要信息）" prop="previously">
				 <el-input v-model="form.previously" placeholder="可以Google drive链接形式提供" ></el-input>
			</el-form-item> 
			<el-form-item label="从哪些渠道了解到EWWAY的?" prop="know">
				 <el-input v-model="form.know" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="希望EWWAY在哪些方面帮到你?" prop="hope">
				 <el-input v-model="form.hope" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="想要发行的区域" prop="regions">
				 <el-input v-model="form.regions" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="想要发行平台（EWway全部发行平台或指定的平台）" prop="dsp">
				 <el-input v-model="form.dsp" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="可通过EWway发行的存量歌曲数量" prop="trackCount">
				 <el-input v-model="form.trackCount" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="未来计划的发行频率（每月发行的歌曲数量）" prop="plannedc">
					 <el-input v-model="form.plannedc" placeholder="" ></el-input>
			</el-form-item>
			<el-form-item label="未来发行歌曲的试听链接" prop="plannedl">
					 <el-input v-model="form.plannedl" placeholder="可以Google drive链接形式提供" ></el-input>
			</el-form-item>
			
			<el-form-item label="主要音乐类型" prop="musicType">
				<el-select v-model="form.musicType" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in musicTypeOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			
			<el-form-item label="" prop="originalSong">
				拥有完整著作权的原创内容
				<el-radio-group v-model="form.originalSong">
				    <el-radio label="yes">yes</el-radio>
				    <el-radio label="no">no</el-radio>
				</el-radio-group>
			</el-form-item> 
			<el-form-item label="音频语言" prop="audioLanguage">
				<el-select v-model="form.audioLanguage" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in audioLanguageOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			
			<el-form-item label="你的艺术家页面" prop="artist">
				<el-button type="primary" size="small" icon="el-icon-plus" plain @click="addArtist">Add Artist</el-button>
				
				<div v-for="(itemF, indexF) in form.artist" :style="{'height': (itemF.length*45)+ 'px',backgroundColor:'#F7F7F7',marginBottom:'20px',padding:'20px'}" >
					<div v-for="(item, index) in itemF" :style="{'height':'50px'}">
						<el-input v-model="item.name" v-if="index==0" placeholder="艺人名称"  style="width: 14%;float: left;margin-bottom: 5px;" ></el-input>
						
						<div style="width:12%;float: right;height: 40px;margin-bottom: 5px;" >
							<div style="width:100%;height: 40px;" >
								<div style="width:20px;float: left;text-align: center; height: 20px;padding: 10px ;" v-if="index==0" @click="addArtItem(indexF)"><img src="@/assets/images/svg/add.svg" /></div>
								<div style="width:20px;float: left;text-align: center; height: 20px;padding: 10px ;" v-if="indexF !=0 && index==0" @click="delArtItem(indexF,index)"><img src="@/assets/images/svg/del.svg" /></div>
								<div style="width:20px;float: left;text-align: center; height: 20px;padding: 10px ;" v-if="index!=0" @click="subArtItem(indexF,index)"><img src="@/assets/images/svg/sub.svg" /></div>
								
								<!-- <el-button type="primary" size="mini" @click="addArtItem(indexF)"  		 plain style="float:left;width:50%;height:40px;margin-left:0;" round v-if="index==0" icon="el-icon-plus"></el-button>
								<el-button type="primary" size="mini" @click="delArtItem(indexF,index)"  plain style="float:left;width:50%;height:40px;margin-left:0;" round v-if="indexF !=0 && index==0" icon="el-icon-delete"></el-button>
								<el-button type="primary" size="mini" @click="subArtItem(indexF,index)"  plain style="float:left;width:50%;height:40px;margin-left:0;" round v-if="index!=0" icon="el-icon-minus"></el-button>
							 -->
							</div>
						</div>
						
						<el-input v-model="item.link" placeholder="艺人主页链接"  style="width: 50%;float: right ;margin-left: 1%;margin-bottom: 5px;"></el-input>
						
						<el-select v-model="item.platform" placeholder="请选择平台"  filterable     style="width: 22%;float: right ;margin-left: 1%;margin-bottom: 5px;" :popper-append-to-body="false" >
							<el-option v-for="(item2, index2) in platformOption" :key="index2" :label="item2.label"
									   :value="item2.value" ></el-option>
						</el-select>
					</div>
					
					
				</div>
				
			</el-form-item>
			
			<!-- <el-form-item label="曲库歌曲数量?" prop="trackCount">
				 <el-input v-model="form.trackCount" placeholder="" ></el-input>
			</el-form-item> -->
			
			<!-- <el-form-item label="你的艺术家在流媒体平台主页（YouTube, Spotify, Apple Music等）" prop="artist">
				<span class="labelSpan" style="left: 425px;"> 在列举多个项目或元素时，使用逗号进行分隔</span>
				 <el-input v-model="form.artist" placeholder="" type="textarea" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item> -->
			
			
			<el-form-item label="情况描述"  prop="description">
			  <el-input v-model="form.description" type="textarea" 	placeholder="曲风类型，曲库数量，艺人听众情况等" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item>
			<el-form-item label="" prop="check1">
			  <el-checkbox v-model="form.check1" ></el-checkbox>
			  <span class="checkBoxClass" >我们尤为注重版权问题，并且坚持严格的反欺诈政策。要通过EWWAY分发内容，必须拥有内容的完整著作权。如果出现与版权相关的任何问题，我们将立即删除内容。感谢您的理解！</span><br>
			</el-form-item>
			
			 <el-button type="primary" @click="add">提交</el-button>
					
		</el-form>
		
	</div>
	
</template>

<script>
import axios from 'axios';
export default {
	name : "Form1",
	data() {
		
		//艺人选择
		const checkArtist = (rule, value, callback) => {
			for (var i = 0; i < value.length; i++) {
				let v = value[i];
				for (var j = 0; j < v.length; j++) {
					let ll = v[j];
					if(i==0&& j==0){
						if(ll['name']==""){
							return callback(new Error( "不能为空" ))
						}
					}
					if(ll['platform']==""){
						return callback(new Error( "不能为空" ))
					}
					if(ll['link']==""){
						return callback(new Error( "不能为空" ))
					}else{
						try {
							new URL(ll['link']);
						} catch (_) {
							return callback(new Error( "网址格式错误" ))
						}
					}
				}
			}
			return callback()
		};
		
		return {
			companyTypeOption:[{"label":"独立音乐人","value":"独立音乐人"},
							{"label":"唱片公司","value":"唱片公司"},
							{"label":"经纪公司","value":"经纪公司"},
							{"label":"分销商/聚合商","value":"分销商/聚合商"},
							{"label":"艺人服务平台","value":"艺人服务平台"},
							{"label":"其他","value":"其他"},
							],
			musicTypeOption:[{"label":"人声音乐","value":"人声音乐"},{"label":"非人声音乐","value":"非人声音乐"}],
			audioLanguageOption:[
							{"label":"中文","value":"中文"},
							{"label":"英文","value":"英文"},
							{"label":"日语","value":"日语"},
							{"label":"韩语","value":"韩语"},
							{"label":"越南语","value":"越南语"},
							{"label":"印度语","value":"印度语"},
							{"label":"其他","value":"其他"},
							],
			//平台信息
			platformOption:[
				{"label":"YouTube Channel","value":"YouTube Channel"},
				{"label":"YouTube Music","value":"YouTube Music"},
				{"label":"Apple Music","value":"Apple Music"},
				{"label":"Spotify","value":"Spotify"},
				{"label":"Deezer","value":"Deezer"},
				{"label":"Soundcloud","value":"Soundcloud"},
				{"label":"AWA","value":"AWA"},
				{"label":"Amazon","value":"Amazon"},
				{"label":"Tencent Music","value":"Tencent Music"},
				{"label":"NetEase Cloud Music","value":"NetEase Cloud Music"},
				{"label":"others","value":"others"},
			],
			form:{
				originalSong : "yes",
				artist:[[{"name":"","platform":"","link":""}]],
				check1:false,
			},
			rules:{
				name: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				eMail: [
				  { required: true, message: "不能为空", trigger: "blur" },
				  {  message: "邮箱格式错误", type:"email", trigger: "blur" }
				],
				country: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				companyType: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				trackCount: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				musicType: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				audioLanguage: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				arrangement: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				know: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				hope: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				artist: [
				  { required: true, validator: checkArtist, trigger: ["blur","change"]  }
				],
				regions: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				description: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				dsp: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				check1: [
				  { required: true, message: "必选", trigger: ["blur","change"] }
				],
				dsp: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],				
				previously: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				plannedc: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				plannedl: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],	
				current: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],	
			},
			loading:false
		}
	},
	methods:{
		
		add(){
			this.$refs["form"].validate(valid => {
				if (valid) {
					this.loading = true
					axios.post('https://cms.ewway.com/ewway-api/feedback/distribution', this.form)
					 // axios.post('dev-api/feedback/distribution', this.form)
						.then(response => {
							this.loading = false
						  // 处理返回的数据
						  if(response.data.code===200){
							 this.$message({
								type: 'success',
								message: "提交成功！我们将尽快处理并回复您的消息，衷心感谢您对我们的关注与支持！",
								customClass :'customClass',
								duration:2000,
							 }); 
							 this.$refs['form'].resetFields();
							 this.form.artist=[[{"name":"","platform":"","link":""}]];
						  }else{
							  this.$message({
								type: 'error',
								message: "提交失败！",
								customClass :'customClass',
								duration:2000,
							  });
						  }
						  
						})
						.catch(error => {
						  console.error(error);
							this.loading = false
						  // 错误处理逻辑
						  this.$message({
									type: 'error',
									message: "提交失败！",
									customClass :'customClass',
									duration:2000,
						  });
						});
				}
					
			});
		}
		,
		//添加艺人
		addArtist(){
			if(this.form.artist.length<5){
				this.form.artist.push([{"name":"","platform":"","link":""}]);
				return ;
			}
			this.$message({
				type: 'error',
				message: "您最多可以添加五位艺人",
				customClass :'customClass',
				duration:2000,
			});
		},
		//添加艺人具体信息
		addArtItem(indexF){
			if(this.form.artist[indexF].length<3){
				this.form.artist[indexF].push({"name":"","platform":"","link":""});
				return ;
			}
			this.$message({
				type: 'error',
				message: "每位艺人最多可以添加三个不同平台的主页链接",
				customClass :'customClass',
				duration:2000,
			});
		},
		delArtItem(indexF,index){
			this.form.artist.splice(indexF,1);
		},
		subArtItem(indexF,index){
			this.form.artist[indexF].splice(index,1);
		},
	}
}
	
	
</script>

<style >
	.df1{
		width:80%;
		margin-left:10%;
		text-align: left;
	}
	.customClass{
		font-size:12px;
	}
	.labelSpan{
		position: absolute;
		top: -50px;
		font-size: 12px;
		color: #A5A3BE;
	}
</style>